<template>
  <div class="order-wrap">
    <template v-if="showTab">
      <Tab
        :mainCardList="mainCardList"
        :currentGroup="currentGroup"
        :handleCardClick="handleCardClick"
        :currentCard="currentCard"
        :handleTabClick="handleTabClick"
      />
    </template>
    <template v-if="!loading">
      <div class="order-list-wrap" v-if="orderList.length > 0">
        <div class="order-item" v-for="item in orderList" :key="item.id">
          <div class="order-header">
            <div class="order-number">订单编号：{{ item.order_number }}</div>
            <div class="order-status">{{ getStateText(item.status) }}</div>
          </div>
          <div class="order-content">
            <van-image
              lazy-load
              fit="contain"
              :src="getImageUrl(item)"
              class="order-image"
            />
            <div class="order-detail">
              <div class="order-title">{{ item.name || item.card_name }}</div>
              <div class="order-time">
                {{
                  (item.t_created || item.createdTime)
                    | formatDate("YYYY-MM-DD HH:mm:ss")
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-empty class="order-empty" description="暂无成功订单" v-else />
    </template>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  ref,
  computed,
} from "@vue/composition-api";
import Vue from "vue";

import { getOrder, getNamespaceGroupMemberOrder } from "@/apis";
import { getUserBenefit } from "@/apis/home";
import { getMutilCardByNg } from "@/apis/product";
import { useStore } from "@/components/use/base";
import { storage, jsonSafeParse } from "@/utils";
import Tab from "../member/component/Tab.vue";

const vm = Vue.prototype;

const DEFAULT_CURRENT_GROUP = {
  children: [],
};

export default defineComponent({
  components: {
    Tab,
  },
  setup() {
    const store = useStore();

    const currentCard = ref({});
    const orderList = ref([]);
    const mainCardList = ref([]);
    const currentGroup = ref(DEFAULT_CURRENT_GROUP);
    const loading = ref(false);
    const showTab = ref(false);

    const namespace = computed(() => store.state.namespace);
    const isMember = computed(() => store.state.isMember);

    const getStateText = computed(() => (status) => {
      return {
        success: "已成功",
        canceled: "已取消",
        confirming: "已支付，确认中",
        refund: "已退款",
        paid: "已支付",
        failed: "已失败",
      }[status];
    });

    const getImageUrl = computed(() => (item) => {
      const payInfo = JSON.parse(item.pay_info || item.payInfo);
      return payInfo.image;
    });

    onMounted(async () => {
      showTab.value = vm.$getConfigValue("MEMBER_ORDER_SHOW_TAB") || false;
      if (showTab.value) {
        await initMemberCard();
        await getOrderList();
      } else {
        await fetchNamespaceGroupMemberOrder();
      }
    });

    const fetchNamespaceGroupMemberOrder = async () => {
      const { data } = await getNamespaceGroupMemberOrder({});
      console.log(data);
      orderList.value = data.cards;
    };

    const initMemberCard = async () => {
      const packageMap = jsonSafeParse(vm.$getConfigValue("BJ_CARD_MAP"));
      const { data } = await getMutilCardByNg();
      const arr = [];
      const handleArr = data.map((item) => {
        return {
          ...item,
          ...packageMap[item.namespace],
        };
      });
      for (let item of handleArr) {
        const index = arr.findIndex((v) => v.group === item.group);
        if (index !== -1) {
          arr[index]?.children.push(item);
          arr[index]?.namespace.push(item.namespace);
        } else {
          arr.unshift({
            group: item.group,
            page: item.page,
            namespace: [item.namespace],
            children: [item],
          });
        }
      }
      mainCardList.value = arr;
      if (isMember.value) {
        currentGroup.value =
          arr.find((v) => v.namespace.includes(namespace.value)) ||
          DEFAULT_CURRENT_GROUP;
        currentCard.value = currentGroup.value.children.find(
          (v) => v.namespace === namespace.value
        );
      } else {
        currentGroup.value = arr[0] || DEFAULT_CURRENT_GROUP;
        currentCard.value = arr[0]?.children[0];
        setStoreAndStorage(
          arr[0]?.children[0].token,
          arr[0]?.children[0].namespace
        );
      }
    };

    const getOrderList = async () => {
      loading.value = true;
      const pageLoading = vm.$loading();
      try {
        await getUserBenefit({
          card_status:
            vm.$getConfigValue("USER_BENEFIT_STAT_CARD_LIST") || undefined,
        });
        const { data } = await getOrder({
          category_type: "vip",
          status: "success",
        });
        orderList.value = data.res_list;
      } finally {
        loading.value = false;
        pageLoading.clear();
      }
    };

    const setStoreAndStorage = async (token, namespace) => {
      storage.setItem("token", token);
      storage.setItem("namespace", namespace);
      store.commit("changeState", {
        token: token,
        namespace: namespace,
      });
      await store.dispatch("fetchNamespace");
      await store.dispatch("fetchUserInfo");
    };

    const handleTabClick = async (item) => {
      if (currentGroup.value.group === item.group) return;
      currentGroup.value = item;
      currentCard.value = item.children[0];
      await setStoreAndStorage(
        item.children[0].token,
        item.children[0].namespace
      );
      await getOrderList();
    };

    const handleCardClick = async (item) => {
      if (currentCard.value.namespace === item.namespace) return;
      currentCard.value = item;
      await setStoreAndStorage(item.token, item.namespace);
      await getOrderList();
    };

    return {
      currentCard,
      orderList,
      getStateText,
      getImageUrl,
      mainCardList,
      currentGroup,
      loading,
      showTab,

      handleTabClick,
      handleCardClick,
    };
  },
});
</script>

<style lang="less" scoped>
.order-wrap {
  background-color: #f8f8f8;
  width: 100%;
}

.order-list-wrap {
  .order-item {
    width: 351px;
    height: 127px;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    margin: 0 auto;
    margin-bottom: 12px;
    margin-top: 24px;

    .order-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f5f5f5;
      margin: 0 16px;
      padding-top: 17px;
      padding-bottom: 10px;

      .order-number {
        font-weight: 500;
        font-size: 13px;
        color: #000000;
        line-height: 18px;
      }

      .order-status {
        font-weight: 500;
        font-size: 12px;
        color: #999999;
        line-height: 17px;
        white-space: nowrap;
      }
    }

    .order-content {
      display: flex;
      height: 80px;
      padding-top: 11px;
      padding-left: 16px;

      .order-image {
        height: 50px;
        width: 50px;
        border-radius: 3px !important;
        overflow: hidden;
      }
    }

    .order-detail {
      flex: 1;
      margin-left: 12px;
      margin-right: 20px;

      .order-title {
        font-weight: 600;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
      }

      .order-time {
        margin-top: 14px;
        font-weight: 400;
        font-size: 11px;
        color: #999999;
        line-height: 16px;
        text-align: right;
      }
    }
  }
}
</style>
